module.exports = __webpack_public_path__ + "img/visual_heroes_post_lossless.23ed1df5.png";